import { ITheme } from "../../../store/slices/theme";
import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    position: "fixed",
    zIndex: theme.zIndex.appBar + 1,
    top: 0,
  },
  bgImg: {
    height: "100%",
    width: "100%",
    objectFit: "cover",
  },
  main: {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(20, 20, 20, 0.70)",
  },
  gameImg: {
    height: 168,
    width: 104,
    borderRadius: theme.radius.small,
    objectFit: "cover",
  },
  progress: {
    width: "104px !important",
    marginTop: theme.spacing.space32,
  },
}));
